@if (isInputLike) {
  <div>
    <blaze-image-column-value
      [value]="value"
      [useExternalClickAction]="true"
      [actionsAlwaysVisible]="isInputLike"
      (clickAction)="externalClickAction($event)"
    />
  </div>
}
@if (!isAddAction) {
  <div #menuTrigger [matMenuTriggerFor]="menu"></div>
  <mat-menu #menu class="bd-menu">
    <a
      [href]="detailValue"
      target="_blank"
      rel="noopener noreferrer"
      download
      mat-menu-item
      disableRipple
    >
      <mat-icon class="text-primary-lighter" svgIcon="icon_download_16" />
      <span class="text-primary-darker">Download</span>
    </a>
    <button mat-menu-item (click)="fileRemove($event)" class="!text-warn">
      <mat-icon svgIcon="icon_trash_16" />
      <span class="!text-warn">Delete</span>
    </button>
  </mat-menu>
}

<input
  #fileInput
  class="hidden"
  type="file"
  [accept]="acceptedExtensions"
  (change)="fileSelected($event.target)"
  (cancel)="closeEditor()"
/>
